import { CefrLevelCode } from 'src/types'

import a1 from '../../../../assets/images/certificates/seal-a1-text.svg'
import a2 from '../../../../assets/images/certificates/seal-a2-text.svg'
import b1 from '../../../../assets/images/certificates/seal-b1-text.svg'
import b2 from '../../../../assets/images/certificates/seal-b2-text.svg'
import c1 from '../../../../assets/images/certificates/seal-c1-text.svg'
import c2 from '../../../../assets/images/certificates/seal-c2-text.svg'

const SEAL_MAP = {
  a1,
  a2,
  b1,
  b2,
  c1,
  c2,
}

export const getSealIcon = (cefrLevel: CefrLevelCode): string | undefined => {
  return SEAL_MAP[cefrLevel]
}

export const getLevelNumber = (cefrLevel: CefrLevelCode): number => {
  return Object.keys(SEAL_MAP).indexOf(cefrLevel) + 1
}
